import React from 'react';
import './FooterPages.css';

const Kontakt = () => {

    return (
        <div className="FooterPages Kontakt grid-container">
            <div className="col-12">
                <h1>Kontakt</h1>
                <h2>Projektteam</h2>
                <p><b>Paul Amelingmeyer</b></p><p>paul-julius.amelingmeyer@stud.hshl.de</p><br/>
                <p><b>Benjamin Jäger</b></p><p>benjamin-noor.jaeger@stud.hshl.de</p><br/>
                <p><b>Steven Kasprzyk</b></p><p>steven.kasprzyk@stud.hshl.de</p><br/>
                <p><b>Simon Weck</b></p><p>simon.weck@stud.hshl.de</p>
            </div>
        </div>
    )
}

export default Kontakt;